export default "__VITE_ASSET__Csz8uHYU__"